import Api from './Api'

export default {
  register (data) {
    return Api().post('/account/register', data)
  },
  login (data) {
    return Api().post('/account/login', data)
  },
  sendResetEmail(data) {
      return Api().post('/email/resetEmail', data)
  },
  changePassword(data) {
      return Api().put('/account/resetPassword', data, {
          headers: { Authorization: "Bearer " + data.token }
      })
  },
  checkTokenAndCode(data) {
    return Api().get('/account/verify?c=' + data.code, {
      headers: { Authorization: "Bearer " + data.token }
    })
  },
}
